<!-- HEAD -->
<app-main-head *ngIf="detailInformation" [breadcrumbItems]="breadcrumbItems" (externalSearchEvent)="searchExt($event)"
    [mainTitle]="parentData.Nome" [isSearchRequired]="true" [breadcrumbItems]="breadcrumbItems"
    [bodyList]="detailInformation" [textPlaceholderSearch]="parentData.Nome">
</app-main-head>
<!-- END HEAD -->

<app-ethics-committee-detail-body *ngIf="detailInformation" [detailInformation]="detailInformation"
    [subDetailInformation]="subDetailInformation" [parentData]="parentData" [id]="filename">
</app-ethics-committee-detail-body>